import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import KeyCode from '../../constants/keys';

const EditableContent = WrappedComponent => {
  class Cmp extends React.Component {
    state = {
      editing: false,
    };

    toggleEdit = e => {
      e.stopPropagation();
      if (!this.state.editing && this.domElm.contains(e.target)) {
        this.edit();
      }
    };

    edit = () => {
      this.setState(
        {
          editing: true,
        },
        () => this.domElm.focus()
      );
    };

    save = () => {
      this.setState(
        {
          editing: false,
        },
        () => this.handelChangeValue()
      );
    };

    cancel = () => {
      this.setState(
        {
          editing: false,
        },
        () => this.handelChangeValue()
      );
    };

    handleKeyDown = e => {
      const { key } = e;
      if (KeyCode.ENTER === key || KeyCode.ESCAPE === key) {
        this.save();
      }
    };

    handelChangeValue = () => {
      this.props.onChangeValueHandler(this.domElm.textContent);
    };

    render() {
      const { editing } = this.state;
      const { className, value } = this.props;

      return (
        <WrappedComponent
          className={className}
          suppressContentEditableWarning={true}
          onClick={this.toggleEdit}
          contentEditable={editing}
          ref={domNode => {
            this.domElm = domNode;
          }}
          onBlur={this.save}
          onKeyDown={this.handleKeyDown}
        >
          {value}
        </WrappedComponent>
      );
    }
  }

  Cmp.propTypes = {
    onChangeValueHandler: PropTypes.func.isRequired,
  };

  return Cmp;
};

export default EditableContent;
